import type { GetRoleListItemDto } from "@/spz-api/model";

export interface RoleListItem {
  id: string;
  name: string;
  description: string | null;
  permissionsCount: number;
  updatedAt: Date | null;
}

export class RoleMapper {
  static toListItem(role: GetRoleListItemDto): RoleListItem {
    return {
      id: role.id,
      name: role.name,
      description: role.description,
      permissionsCount: role.permissionsCount,
      updatedAt: new Date(role.updatedAt),
    };
  }

  static toListItems(dtos: GetRoleListItemDto[]): RoleListItem[] {
    return dtos.map(RoleMapper.toListItem);
  }
}
